import { useEffect } from "react";

// Gold diamond cursor + fading trail (desktop only) and gold tap ripple (all devices)
export function GoldCursor({ active = true }) {
  useEffect(() => {
    if (!active) return undefined;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const fine = window.matchMedia("(pointer: fine)").matches;

    const onDown = (e) => {
      if (reduced) return;
      const r = document.createElement("span");
      r.className = "gc-ripple";
      r.style.left = `${e.clientX}px`;
      r.style.top = `${e.clientY}px`;
      document.body.appendChild(r);
      setTimeout(() => r.remove(), 520);
    };
    window.addEventListener("pointerdown", onDown);

    let cursorEl = null;
    let onMove = null;
    let lastTrail = 0;
    if (fine && !reduced) {
      document.body.classList.add("gold-cursor");
      cursorEl = document.createElement("div");
      cursorEl.className = "gc-diamond";
      cursorEl.setAttribute("data-testid", "gold-cursor");
      document.body.appendChild(cursorEl);
      onMove = (e) => {
        cursorEl.style.left = `${e.clientX}px`;
        cursorEl.style.top = `${e.clientY}px`;
        const now = performance.now();
        if (now - lastTrail > 28) {
          lastTrail = now;
          const t = document.createElement("span");
          t.className = "gc-trail";
          t.style.left = `${e.clientX}px`;
          t.style.top = `${e.clientY}px`;
          document.body.appendChild(t);
          setTimeout(() => t.remove(), 500);
        }
      };
      window.addEventListener("pointermove", onMove);
    }

    return () => {
      window.removeEventListener("pointerdown", onDown);
      if (onMove) window.removeEventListener("pointermove", onMove);
      document.body.classList.remove("gold-cursor");
      if (cursorEl) cursorEl.remove();
    };
  }, [active]);
  return null;
}
